import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Instagram, ZoomIn, X } from 'lucide-react';
export function Gallery() {
  const images = ['https://images.unsplash.com/photo-1545205597-3d9d02c29597?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1510894347713-fc3ed6fdf539?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1593164842264-854604db2260?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1552286450-37b5f6358cb7?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1528319725582-ddc096101511?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1603988363607-e1e4a66962c6?auto=format&fit=crop&q=80&w=800'];
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  return <section id="gallery" className="py-24 bg-yoga-dark text-white" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-229">
          <FadeIn className="max-w-2xl" data-id="element-230">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-231">
              Studio Gallery
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-232">
              A glimpse inside our studio
            </h2>
            <p className="text-lg text-gray-400" data-id="element-233">
              Experience the serene environment and vibrant community at Shree
              Yoga Fitness.
            </p>
          </FadeIn>
          <FadeIn delay={200} data-id="element-234">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 px-6 py-3 rounded-full transition-colors font-bold" data-id="element-235">
              <Instagram className="w-5 h-5 text-yoga-primary" data-id="element-236" /> Follow on
              Instagram
            </a>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-237">
          {images.map((img, idx) => <FadeIn key={idx} delay={idx * 50} data-id="element-238">
              <div className="relative aspect-square rounded-xl overflow-hidden group cursor-pointer" onClick={() => setSelectedImage(img)} data-id="element-239">
                <img src={img} alt={`Yoga studio gallery ${idx + 1}`} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-240" />
                <div className="absolute inset-0 bg-yoga-dark/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm" data-id="element-241">
                  <ZoomIn className="w-8 h-8 text-white" data-id="element-242" />
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 backdrop-blur-md" data-id="element-243">
          <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors" onClick={() => setSelectedImage(null)} aria-label="Close lightbox" data-id="element-244">
            <X className="w-10 h-10" data-id="element-245" />
          </button>
          <img src={selectedImage} alt="Enlarged gallery view" className="max-w-full max-h-[90vh] object-contain rounded-lg" data-id="element-246" />
        </div>}
    </section>;
}